import { createRoot } from 'react-dom/client';
import { ROOT_EL, VERSION } from '@/base/constants';
import { log } from '@/base/log';
import { base, routes } from '$/public';
import { Workspace } from '$/Workspace';

log('info', 'public workspace started', VERSION);

createRoot(ROOT_EL).render(<Workspace base={base} routes={routes} />);
